@if (form && control) {
  <div [formGroup]="form">
    <app-material-select2-autocomplete
      [formControlName]="field_name"
      [placeholder]="placeholder"
      [caption]="caption"
      [api_action]="api_action">
      @if (value) {
        <option value="value">{{value_caption}}</option>
      }
      @if (!value) {
        <option value=""></option>
      }
    </app-material-select2-autocomplete>
  </div>
}
